import { Chat, ChevronRight } from "@mui/icons-material";
import { Box, Collapse, Drawer, IconButton, Paper } from "@mui/material";
import { atom, useAtom } from "jotai";

export const DEFAULT_WIDTH = "600px";
export const DEFAULT_SLIM_WIDTH = "0px";

type RightPanelVariant = "drawer" | "collapse";

const CONTENT_Z_INDEX = 0;
const CollapseIcon = () => {
  const [expanded, setExpanded] = useAtom(rightPanelExpanded);

  const Icon = !expanded ? <Chat /> : <ChevronRight />;
  return (
    <Box
      width={0}
      position={"relative"}
      height={"100%"}
      display={"flex"}
      alignItems={"center"}
      sx={{
        displayPrint: "none",
      }}
    >
      <IconButton
        sx={{
          p: 1,
          pr: 0.5,
          background: (theme) => theme.palette.grey[100],
          border: (theme) => `2px solid ${theme.palette.grey[400]}`,
          color: (theme) => theme.palette.grey[500],
          position: "absolute",
          cursor: "pointer",
          borderRadius: 0,
          ...(!expanded
            ? {
                right: "-2px",
                borderTopLeftRadius: "16px",
                borderBottomLeftRadius: "16px",
                zIndex: CONTENT_Z_INDEX,
              }
            : {
                right: "-2px",
                borderTopLeftRadius: "16px",
                borderBottomLeftRadius: "16px",
                zIndex: CONTENT_Z_INDEX,
              }),
          "&:hover": {
            background: (theme) => theme.palette.grey[300],
          },
        }}
        onClick={() => {
          setExpanded((prev) => !prev);
        }}
      >
        {Icon}
      </IconButton>
    </Box>
  );
};

export const RightPanel = () => {
  const [{ variant, open, content }] = useAtom(rightPanelAtom);
  const [expanded] = useAtom(rightPanelExpanded);
  switch (variant) {
    case "drawer":
      return (
        <Drawer
          open={open}
          anchor="right"
          variant={"persistent"}
          PaperProps={{
            elevation: 12,
            sx: {
              overflow: "visible",
              width: DEFAULT_WIDTH,
            },
          }}
        >
          {content?.()}
        </Drawer>
      );
    case "collapse":
      return (
        <Box display={"flex"}>
          {open && <CollapseIcon />}

          <Collapse in={open} orientation={"horizontal"}>
            <Collapse
              in={expanded}
              orientation={"horizontal"}
              collapsedSize={DEFAULT_SLIM_WIDTH}
              sx={{
                height: "100%",
                display: "flex",
              }}
            >
              <Paper
                sx={{
                  height: "100%",
                  position: "relative",
                  display: "flex",
                  width: DEFAULT_WIDTH,
                }}
              >
                {content?.()}
              </Paper>
            </Collapse>
          </Collapse>
        </Box>
      );
  }
};

export const rightPanelExpanded = atom(true);

export const rightPanelAtom = atom<{
  open: boolean;
  variant: RightPanelVariant;
  content?: () => JSX.Element;
}>({
  open: false,
  variant: "drawer",
});
